/**
 * Clarity x CookieYes consent implementation
 *
 * Potential race condition here as we need to use events from CookieYes
 * but that may happen before Clarity has loaded.
 *
 * It will try a few times before giving up and logging a warning.
 */
function determineClarityConsent() {
    console.debug('Determine Clarity consent status');

    if ('clarity' in window && 'getCkyConsent' in window) {
        console.debug('Clarity is available and CookieYes is loaded');

        let consentData = window.getCkyConsent();
        // check whether we already have consent so we can set Clarity consent immediately
        if (consentData?.categories && 'analytics' in consentData?.categories) {
            setClarityConsent(consentData.categories.analytics);
        }
    } else {
        console.info('Clarity x CookieYes consent: called too early, clarity or cookieyes not available yet!', {
            clarity: 'clarity' in window,
            cookieyes: 'getCkyConsent' in window,
        });
    }

    // wait for user consent change and react accordingly
    document.addEventListener('cookieyes_consent_update', function (eventData) {
        let analyticsPresent = eventData.detail.accepted.includes('analytics') || eventData.detail.rejected.includes('analytics');
        let allowsAnalytics = eventData.detail.accepted.includes('analytics');

        if (!analyticsPresent) {
            // analytics group missing??? can't be sure they allow it or not then.
            console.warn('CookieYes: Analytics group not defined.');
            return;
        }

        setClarityConsent(allowsAnalytics);
    });
}

function setClarityConsent(accepted) {
    console.debug('Setting Clarity consent to', accepted);

    window.clarity('consent', accepted);
}

document.addEventListener('cookieyes_banner_load', function (eventData) {
    let intervalCounter = 0;
    let waitForClarity = setInterval(_ => {
        if ('clarity' in window) {
            clearInterval(waitForClarity);
            try {
                determineClarityConsent();
            } catch (e) {
                console.error('Failed to initialise Clarity/CookieYes consent', e);
            }
        }

        if (intervalCounter > 10) {
            console.warn('Clarity/CookieYes: Clarity not loaded in time');
            clearInterval(waitForClarity);
        }

        intervalCounter++;
    }, 100);
});
